function generateMortgageBondHistory({
  companyName = "MortgageBond",
  behavior = "mortgage",
  faceValue = 1000,                   // $1000 face value per bond unit
  couponRate = 0.05,                  // Annual coupon rate
  termYears = 30,
  startMarketRate = 0.05,
  marketRateDrift = -0.0005,
  prepaymentMode = "off",            // Options: "off", "light", "realistic"
  monthAdjust = 0,
  createHeader = true
}) {
  const months = termYears * 12;
  const monthlyCouponRate = couponRate / 12;

  // Determine prepayment parameters
  let prepaymentChance = 0;
  let maxPrepaymentPercent = 0;

  if (prepaymentMode === "light") {
    prepaymentChance = 0.01;           // 1% chance monthly
    maxPrepaymentPercent = 0.02;       // 2% of remaining principal
  } else if (prepaymentMode === "realistic") {
    prepaymentChance = 0.02;
    maxPrepaymentPercent = 0.08;
  }

  const monthlyPayment = calculateMonthlyPayment(faceValue, couponRate, months);
  let remainingPrincipal = faceValue;
  let marketRate = startMarketRate;

  const csvRows = [];

  if (createHeader) {
    csvRows.push({
      company: "investShortName",
      behavior: "behavior",
      monthNbr: "monthNbr",
      close: "closingPrice",
      open: "openPrice",
      high: "highPrice",
      low: "lowPrice",
      volume: "volume"
    });
  }

  for (let i = 0; i < months; i++) {
    const monthNbr = (i + 1 + monthAdjust).toString();

    const interestPayment = remainingPrincipal * monthlyCouponRate;
    const principalPayment = monthlyPayment - interestPayment;

    let prepayment = 0;
    if (Math.random() < prepaymentChance && remainingPrincipal > 0) {
      prepayment = Math.min(
        remainingPrincipal * maxPrepaymentPercent,
        remainingPrincipal - principalPayment
      );
    }

    remainingPrincipal -= (principalPayment + prepayment);
    remainingPrincipal = Math.max(remainingPrincipal, 0);

    // Simulate bond price based on remaining principal and rate conditions
    const durationScale = remainingPrincipal / faceValue;
    const baseDuration = 5; // typical MBS average duration
    const effectiveDuration = baseDuration * durationScale;
    const rateDiff = marketRate - couponRate;

    let estimatedPrice = faceValue * (1 - rateDiff * effectiveDuration);
    estimatedPrice = Math.max(0, Math.min(estimatedPrice, remainingPrincipal));

    // Wiggle to simulate market noise
    const wiggle = 0.005;
    const openPrice = estimatedPrice * (1 + (Math.random() - 0.5) * wiggle);
    const closePrice = estimatedPrice * (1 + (Math.random() - 0.5) * wiggle);
    const highPrice = Math.max(openPrice, closePrice) * (1 + Math.random() * 0.01);
    const lowPrice = Math.min(openPrice, closePrice) * (1 - Math.random() * 0.01);

    csvRows.push({
      company: companyName,
      behavior: behavior,
      monthNbr,
      close: closePrice.toFixed(2),
      open: openPrice.toFixed(2),
      high: highPrice.toFixed(2),
      low: lowPrice.toFixed(2),
      volume: "0.00"
    });

    marketRate += marketRateDrift;
  }

  return csvRows;
}

// Utility: Monthly amortizing payment for fixed-rate loan
function calculateMonthlyPayment(principal, annualRate, termMonths) {
  if (annualRate === 0) return principal / termMonths;
  const r = annualRate / 12;
  return (r * principal) / (1 - Math.pow(1 + r, -termMonths));
}

export default generateMortgageBondHistory;